<div *ngIf="data.type=='edit'" class="dialog-overlay">
    <div class="business-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Edit Business Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <img src="/assets/images/close.svg" alt="close" width="16" height="16">
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                            <label>Business ID</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="id" class="infofield" required
                                    placeholder="Business ID" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('company_id')?.errors?.['required'] && form.get('company_id')?.touched">
                                    Business ID is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Business Name</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required
                                    placeholder="Business Name" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Business name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Head</label>
                            <div class="col-sm-12">
                                <div class="search-container">
                                    <ng-select class="custom" [items]="empList" bindLabel="name" formControlName="head"
                                        placeholder="Select Head" [searchable]="true" [multiple]="false">
                                    </ng-select>
                                </div>
                                <div class="erroMessage"
                                    *ngIf="form.get('head')?.errors?.['required']">
                                    Head is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Abbreviation</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="abbr" class="infofield" placeholder="000">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="!form.valid"
                (click)="onSubmit()">Update Business</button>
        </div>
    </div>
</div>

<div *ngIf="data.type=='create'" class="dialog-overlay">
    <div class="business-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Add Business Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <img src="/assets/images/close.svg" alt="close" width="16" height="16">
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                            <label>Business Name</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required
                                    placeholder="Business Name">
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Business name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Head</label>
                            <div class="col-sm-12">
                                <div class="search-container">
                                    <ng-select class="custom" [items]="empList" bindLabel="name" formControlName="head"
                                        placeholder="Select Head" [searchable]="true" [multiple]="false">
                                    </ng-select>
                                </div>
                                <div class="erroMessage"
                                    *ngIf="form.get('head')?.errors?.['required']">
                                    Head is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Abbreviation</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="abbr" class="infofield" placeholder="000">
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <!-- Empty column for layout consistency -->
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="!form.valid"
                (click)="onSubmit()">Save Business</button>
        </div>
    </div>
</div>